import i18n from '@/plugins/i18n';
import { NajizToaster } from '@moj/najiz-toastify';

export class ErrorHandler {
  public static errorResponseHandler(error: any) {
    const errorStatus = error.response.status;

    const getErrorMessages = (status: string) => ({
      500: i18n.t('serverErrors.SERVER_ERROR') as string,
    }[status]);

    const message = getErrorMessages(errorStatus) || '';

    if (message) {
      NajizToaster.error({ message });
    }

    return Promise.reject(error);
  }
}
